import React, { useState } from 'react'
import TableHeader from './TableHeader'
import TableBody from './TableBody'
import { useSelector } from 'react-redux';
import UserModal from '../../pages/userManagement/user/UserModal';
import VehicleModal from '../../pages/assetManagement/vehicle/VehicleModal';
import EmployeeModal from '../../pages/assetManagement/employee/EmployeeModal';
import PropertyModal from '../../pages/assetManagement/property/PropertyModal';
import ClientModal from '../../pages/userManagement/client/ClientModal';
import { GenerateLinkModal } from '../GenerateLinkModal';
import DirectClaim from '../../pages/claims/DirectClaim/DirectClaim';
import PolicyModal from '../../pages/policy/PolicyModal';
import { useGetPermission } from '../../hooks/useGetPermission';
import { getModuleByTabId } from '../../utils/getModuleByTabId';
import ThirdPartyModal from '../../pages/thirdParty/ThirdPartyModal';
import DirectClaimModal from '../../pages/claims/DirectClaim/DirectClaimModal';

function Table({ columns, sortColumn, onSort = () => { }, data, className, checkboxClick, checkedItems, hideCheckbox }) {
    const [openModal, setOpenModal] = useState({ userModal: false, clientModal: false, mvrModal: false, thirdPartyModal: false, incidentModal: false, claimModal: false, employeeModal: false, vehicleModal: false, propertyModal: false, policyModal: false })
    const selectedTabIdState = useSelector((state) => state.selectedTabId)
    const createPermission = useGetPermission(getModuleByTabId(selectedTabIdState), 'CREATE')

    let tableView = !hideCheckbox ?
        (<table className="table table-hover mt-3">
            <TableHeader
                columns={columns}
                sortColumn={sortColumn}
                onSort={onSort}
                checkboxClick={checkboxClick}
                checked={(data.length === checkedItems.length)}
            />
            <TableBody checkboxClick={checkboxClick} checkedItems={checkedItems} columns={columns} data={data} />
        </table>) : (
            <table className="table table-hover mt-3">
                <TableHeader
                    hideCheckbox={true}
                    columns={columns}
                    sortColumn={sortColumn}
                    onSort={onSort}
                />
                <TableBody hideCheckbox={true} columns={columns} data={data} />
            </table>
        );

    const renderswitch = () => {
        switch (selectedTabIdState) {
            case 'user':
            case 'client':
                return (
                    <g id="Group_9" data-name="Group 9"
                        transform="translate(-562 -325)">
                        <rect id="Rectangle_3349"
                            data-name="Rectangle 3349" width="238"
                            height="238" rx="119"
                            transform="translate(562 325)"
                            fill="#f4f7fe" />
                        <g id="user_1_" data-name="user (1)"
                            transform="translate(629.199 379.395)">
                            <path id="Path_16984" data-name="Path 16984"
                                d="M39.485,66.969A33.485,33.485,0,1,0,6,33.485,33.485,33.485,0,0,0,39.485,66.969Zm0-55.808A22.323,22.323,0,1,1,17.162,33.485,22.323,22.323,0,0,1,39.485,11.162Z"
                                transform="translate(10.742 0)"
                                fill="#207be3" />
                            <path id="Path_16985" data-name="Path 16985"
                                d="M53.227,14A50.283,50.283,0,0,0,3,64.227a5.581,5.581,0,1,0,11.162,0,39.065,39.065,0,0,1,78.131,0,5.581,5.581,0,1,0,11.162,0A50.283,50.283,0,0,0,53.227,14Z"
                                transform="translate(-3 64.131)"
                                fill="#207be3" />
                        </g>
                    </g>
                );
            case 'mvr':
            case 'mvr_submission':
            case 'approved':
            case 'not_approved':
            case 'all_approvals':
                return (
                    <g id="Group_10" data-name="Group 10"
                        transform="translate(-562 -325)">
                        <rect id="Rectangle_3349"
                            data-name="Rectangle 3349" width="238"
                            height="238" rx="119"
                            transform="translate(562 325)"
                            fill="#f4f7fe"></rect>
                        <path id="id-badge"
                            d="M97.9,20.611H77.292V15.458a15.458,15.458,0,0,0-30.917,0v5.153H25.764A25.8,25.8,0,0,0,0,46.375V97.9a25.8,25.8,0,0,0,25.764,25.764H97.9A25.8,25.8,0,0,0,123.667,97.9V46.375A25.8,25.8,0,0,0,97.9,20.611ZM56.68,15.458a5.153,5.153,0,0,1,10.306,0V25.764a5.153,5.153,0,0,1-10.306,0ZM113.361,97.9A15.458,15.458,0,0,1,97.9,113.361H25.764A15.458,15.458,0,0,1,10.306,97.9V46.375A15.458,15.458,0,0,1,25.764,30.917H47.323a15.366,15.366,0,0,0,29.02,0H97.9a15.458,15.458,0,0,1,15.458,15.458ZM51.528,51.528H25.764a5.153,5.153,0,0,0-5.153,5.153V97.9a5.153,5.153,0,0,0,5.153,5.153H51.528A5.153,5.153,0,0,0,56.68,97.9V56.68A5.153,5.153,0,0,0,51.528,51.528ZM46.375,92.75H30.917V61.833H46.375Zm56.68-15.458A5.153,5.153,0,0,1,97.9,82.444H72.139a5.153,5.153,0,0,1,0-10.306H97.9A5.153,5.153,0,0,1,103.055,77.292Zm0-20.611A5.153,5.153,0,0,1,97.9,61.833H72.139a5.153,5.153,0,0,1,0-10.306H97.9A5.153,5.153,0,0,1,103.055,56.68ZM92.75,97.9a5.153,5.153,0,0,1-5.153,5.153H72.139a5.153,5.153,0,0,1,0-10.306H87.6A5.153,5.153,0,0,1,92.75,97.9Z"
                            transform="translate(618.667 381.667)"
                            fill="#207be3"></path>
                    </g>
                );

            case 'thirdParty':
                return (
                    <g id="Group_10" data-name="Group 10"
                        transform="translate(-562 -325)">
                        <rect id="Rectangle_3349"
                            data-name="Rectangle 3349" width="238"
                            height="238" rx="119"
                            transform="translate(562 325)"
                            fill="#f4f7fe" />
                        <path id="id-badge"
                            d="M97.9,20.611H77.292V15.458a15.458,15.458,0,0,0-30.917,0v5.153H25.764A25.8,25.8,0,0,0,0,46.375V97.9a25.8,25.8,0,0,0,25.764,25.764H97.9A25.8,25.8,0,0,0,123.667,97.9V46.375A25.8,25.8,0,0,0,97.9,20.611ZM56.68,15.458a5.153,5.153,0,0,1,10.306,0V25.764a5.153,5.153,0,0,1-10.306,0ZM113.361,97.9A15.458,15.458,0,0,1,97.9,113.361H25.764A15.458,15.458,0,0,1,10.306,97.9V46.375A15.458,15.458,0,0,1,25.764,30.917H47.323a15.366,15.366,0,0,0,29.02,0H97.9a15.458,15.458,0,0,1,15.458,15.458ZM51.528,51.528H25.764a5.153,5.153,0,0,0-5.153,5.153V97.9a5.153,5.153,0,0,0,5.153,5.153H51.528A5.153,5.153,0,0,0,56.68,97.9V56.68A5.153,5.153,0,0,0,51.528,51.528ZM46.375,92.75H30.917V61.833H46.375Zm56.68-15.458A5.153,5.153,0,0,1,97.9,82.444H72.139a5.153,5.153,0,0,1,0-10.306H97.9A5.153,5.153,0,0,1,103.055,77.292Zm0-20.611A5.153,5.153,0,0,1,97.9,61.833H72.139a5.153,5.153,0,0,1,0-10.306H97.9A5.153,5.153,0,0,1,103.055,56.68ZM92.75,97.9a5.153,5.153,0,0,1-5.153,5.153H72.139a5.153,5.153,0,0,1,0-10.306H87.6A5.153,5.153,0,0,1,92.75,97.9Z"
                            transform="translate(618.667 381.667)"
                            fill="#207be3" />
                    </g>
                );

            case 'claim':
                return (
                    <g id="Group_11" data-name="Group 11" transform="translate(-562 -325)">
                        <rect id="Rectangle_3349" data-name="Rectangle 3349" width="238" height="238" rx="119" transform="translate(562 325)" fill="#f4f7fe"></rect>
                        <path id="ambulance" d="M118.335,59.821,109,38.82A30.8,30.8,0,0,0,80.851,20.53h-6.93L70.533,6.968a9.209,9.209,0,0,0-17.864,0L49.281,20.53H25.667A25.7,25.7,0,0,0,0,46.2V87.264a15.369,15.369,0,0,0,10.631,14.569,17.453,17.453,0,0,0-.364,3.4,17.967,17.967,0,1,0,35.934,0,17.787,17.787,0,0,0-.21-2.567H77.211a17.788,17.788,0,0,0-.21,2.567,17.967,17.967,0,0,0,35.934,0,17.453,17.453,0,0,0-.364-3.4A15.369,15.369,0,0,0,123.2,87.264V82.757A56.108,56.108,0,0,0,118.335,59.821ZM99.619,42.994l5.991,13.47H87.268a5.133,5.133,0,0,1-5.133-5.133V30.889a20.534,20.534,0,0,1,17.484,12.1ZM35.934,105.231a7.7,7.7,0,1,1-15.4,0,7.279,7.279,0,0,1,.477-2.567H35.456a7.279,7.279,0,0,1,.477,2.567Zm59.034,7.7a7.7,7.7,0,0,1-7.7-7.7,7.279,7.279,0,0,1,.477-2.567H102.19a7.279,7.279,0,0,1,.477,2.567A7.7,7.7,0,0,1,94.968,112.931Zm17.967-25.667A5.133,5.133,0,0,1,107.8,92.4H15.4a5.133,5.133,0,0,1-5.133-5.133V46.2a15.4,15.4,0,0,1,15.4-15.4h46.2V51.33a15.4,15.4,0,0,0,15.4,15.4H110a45.769,45.769,0,0,1,2.931,16.026ZM56.467,61.6a5.133,5.133,0,0,1-5.133,5.133H46.2v5.133a5.133,5.133,0,0,1-10.267,0V66.731H30.8a5.133,5.133,0,0,1,0-10.267h5.133V51.33a5.133,5.133,0,0,1,10.267,0v5.133h5.133A5.133,5.133,0,0,1,56.467,61.6Z" transform="translate(619.132 378.668)" fill="#207be3"></path>
                    </g>
                );

            case 'employee':
                return (
                    <g id="Group_16" data-name="Group 16"
                        transform="translate(-562 -325)">
                        <rect id="Rectangle_3349"
                            data-name="Rectangle 3349" width="238"
                            height="238" rx="119"
                            transform="translate(562 325)"
                            fill="#f4f7fe" />
                        <g id="_147503" data-name="147503"
                            transform="translate(579.428 1646.513)">
                            <path id="Path_17036" data-name="Path 17036"
                                d="M99.515-1279.546c-2.856.241-3.771.349-5.29.59a42.144,42.144,0,0,0-23.809,12.363,44.79,44.79,0,0,0-7.892,10.989,57.754,57.754,0,0,0-6.085,27.87l.084,2.314.807.072c.434.036,1.217.108,1.723.144l.928.085.06.494c.036.265.12,1.121.2,1.88a46.282,46.282,0,0,0,1.145,6.446A44.706,44.706,0,0,0,80.2-1189.61l1.229.807-.988.265a28.454,28.454,0,0,0-12.025,7.483,50.028,50.028,0,0,0-9.82,14.266c-4.808,9.892-7.639,21.773-8.3,34.895a6.742,6.742,0,0,0,.048,1.831c.241.615,3.711,2.8,5.808,3.639a10.578,10.578,0,0,0,4.627.964,7.635,7.635,0,0,0,5-1.494,13.876,13.876,0,0,0,3.8-4.35l.458-.807.7.41a31.449,31.449,0,0,0,9.025,3.109,81.423,81.423,0,0,0,17.11,1.434,112.8,112.8,0,0,0,15.664-.952c7.543-.952,14.278-2.578,18.532-4.482l1.35-.6.446.807c1.566,2.856,2.145,3.687,3.35,4.808,3.3,3.084,7.952,2.7,14.037-1.169,2.832-1.807,2.7-1.59,2.591-4.024-.976-23.375-8.459-46.474-18.134-55.992a16.073,16.073,0,0,0-5.386-3.687c-.265-.1-.229-.145.458-.711a62.664,62.664,0,0,0,5.3-5.482,46.625,46.625,0,0,0,9.929-34.22,47.119,47.119,0,0,0-5.9-18.182,8.4,8.4,0,0,1-.542-1.024c0-.048,1.856-2.7,4.133-5.892s4.169-5.868,4.217-5.952a44.1,44.1,0,0,0-5.82-3.735,98.643,98.643,0,0,0-20.3-9.025,61.46,61.46,0,0,0-17.592-2.88C101.467-1279.57,99.816-1279.57,99.515-1279.546Zm15.242,96.345c-.482,1.012-1.121,2.47-1.422,3.229-.614,1.555-1.892,5.362-1.892,5.615,0,.3-.181.157-.8-.651a57.815,57.815,0,0,0-6.88-7.218l-.747-.614,1.289-.084a45.247,45.247,0,0,0,9.543-1.566c.819-.241,1.518-.458,1.554-.482C115.7-1185.273,115.5-1184.742,114.757-1183.2Z"
                                transform="translate(0 0)"
                                fill="#207be3" />
                        </g>
                    </g>
                );

            case 'vehicle':
                return (
                    <g id="Group_14" data-name="Group 14"
                        transform="translate(-562 -325)">
                        <rect id="Rectangle_3349"
                            data-name="Rectangle 3349" width="238"
                            height="238" rx="119"
                            transform="translate(562 325)"
                            fill="#f4f7fe" />
                        <g id="_1299198" data-name="1299198"
                            transform="translate(589.944 948.426)">
                            <path id="Path_17004" data-name="Path 17004"
                                d="M50.673-534.473c-1.491.422-1.421.366-1.52,1.562a7.423,7.423,0,0,1-.169,1.2c-.084.141-3.461,1.477-8.3,3.292-6.3,2.35-14.8,5.839-16.5,6.8a17.427,17.427,0,0,1-3.517,1.463c-.324.07-1.379.2-2.321.267s-2.35.267-3.123.422a50.013,50.013,0,0,1-7.921.8l-2.856.084-.6.929c-.83,1.28-.844,1.337-.366,1.829.521.52.535.914.042,2.11-.352.872-.38,1.1-.436,3.6l-.056,2.673-.535.45C1.2-505.9.614-504.054.6-501.114a51.152,51.152,0,0,0,.366,6.782,2,2,0,0,0,1.013,1.716A9.465,9.465,0,0,1,4.2-490.027c.9,1.773,7.513,2.969,19.472,3.517l1.294.056-.084-1.674a14.534,14.534,0,0,1,.689-5.389A15.376,15.376,0,0,1,36.21-503.674a10.608,10.608,0,0,1,3.911-.394,11.048,11.048,0,0,1,3.911.38,14.951,14.951,0,0,1,7.091,4.249,14.69,14.69,0,0,1,3.855,6.922,11.879,11.879,0,0,1,.324,3.925,22.622,22.622,0,0,1-.225,3.7l-.211,1.027,42.293-.1c23.257-.056,42.307-.113,42.335-.127s-.113-.521-.281-1.14a11.4,11.4,0,0,1-.31-3.644,10.542,10.542,0,0,1,.38-3.925,15.422,15.422,0,0,1,12.451-11.213,19.387,19.387,0,0,1,6.078.3,15.725,15.725,0,0,1,8.456,5.614,18.465,18.465,0,0,1,2.6,5.431,10.773,10.773,0,0,1,.38,3.658,14.4,14.4,0,0,1-.225,3.292,7.767,7.767,0,0,0-.211,1.069c.028.014.872-.028,1.871-.084,3.742-.225,6.444-.633,7.386-1.111a4.421,4.421,0,0,0,1.787-2.054l.338-.732-.225-2.209a11.008,11.008,0,0,1,.056-4c.886-5.459.7-9.567-.492-11.284-1.885-2.715-7.4-4.727-20.105-7.3a135.889,135.889,0,0,0-28.6-2.955c-3.208,0-3.18,0-4.882-1.2-2.631-1.843-14.7-8.54-20.7-11.467C99.86-531.673,94.162-533,85-533.713c-2.926-.239-15.561-.225-19.7,0-1.7.1-4.418.267-6.05.38-4.249.309-4.024.309-4.8-.141C52.488-534.613,51.827-534.8,50.673-534.473Zm26.521,4.685c.084.521.535,3.349,1,6.275s.929,5.937,1.055,6.669a9.165,9.165,0,0,1,.183,1.365c-.155.126-23.9-.408-27.449-.619a52.812,52.812,0,0,1-6.824-.76,5.93,5.93,0,0,1-3.5-3.25,4.785,4.785,0,0,1-.07-3.588,2.028,2.028,0,0,1,.957-1.21,17.072,17.072,0,0,1,3.56-1.787c4.8-1.914,12.072-3.236,20.541-3.757,3.785-.225,3.8-.225,7.189-.253l3.194-.028Zm8.864-.661a86.75,86.75,0,0,1,14.477,2.617,47.122,47.122,0,0,1,10.636,5.445c2.969,1.885,3.855,2.547,3.517,2.6a2.99,2.99,0,0,0-2.279,1.491,4.248,4.248,0,0,0-.056,2.518l.155.38-12.761-.028L87-515.465l-.83-2.251c-1.548-4.249-4.193-12.353-4.193-12.888A25.413,25.413,0,0,1,86.058-530.449Z"
                                transform="translate(0 0)"
                                fill="#3588e6" />
                            <path id="Path_17005" data-name="Path 17005"
                                d="M189.738-313.723a14.229,14.229,0,0,0-7.991,4.305,14.422,14.422,0,0,0-3.686,6.57,10.773,10.773,0,0,0-.366,3.475,12.07,12.07,0,0,0,.915,5.375,14.928,14.928,0,0,0,6.936,7.752,15.468,15.468,0,0,0,3.813,1.379,17.644,17.644,0,0,0,5.9-.014,14.817,14.817,0,0,0,11.284-10.707,11.225,11.225,0,0,0,.38-3.574,11.581,11.581,0,0,0-.647-4.643,14.8,14.8,0,0,0-9.4-9.412A15.735,15.735,0,0,0,189.738-313.723Zm4.924,4.235a10.688,10.688,0,0,1,7.64,7.021,7.208,7.208,0,0,1,.394,3.1,8.973,8.973,0,0,1-1.041,4.854,10.79,10.79,0,0,1-6.824,5.431,12.788,12.788,0,0,1-5.065,0,10.469,10.469,0,0,1-7.907-9.581,10.434,10.434,0,0,1,7.851-10.763A12.74,12.74,0,0,1,194.663-309.488Z"
                                transform="translate(-152.178 -189.642)"
                                fill="#3588e6" />
                            <path id="Path_17006" data-name="Path 17006"
                                d="M246.853-271.767a9.828,9.828,0,0,0-1.534.717l-.619.394,1.632,1.618c1.14,1.154,1.688,1.6,1.843,1.548.2-.084.225-.408.225-2.35C248.4-272.456,248.485-272.343,246.853-271.767Z"
                                transform="translate(-209.757 -225.577)"
                                fill="#3588e6" />
                            <path id="Path_17007" data-name="Path 17007"
                                d="M292-270.021c0,1.956.028,2.279.225,2.364.155.056.7-.394,1.829-1.52l1.618-1.6-.394-.31a8.038,8.038,0,0,0-2.715-1.112l-.563-.1Z"
                                transform="translate(-250.402 -225.409)"
                                fill="#3588e6" />
                            <path id="Path_17008" data-name="Path 17008"
                                d="M220.294-245.831A11.063,11.063,0,0,0,219-242.666c0,.141.478.183,2.321.183,2.124,0,2.321-.014,2.321-.253A22.757,22.757,0,0,0,220.534-246C220.477-246,220.379-245.916,220.294-245.831Z"
                                transform="translate(-187.672 -248.009)"
                                fill="#3588e6" />
                            <path id="Path_17009" data-name="Path 17009"
                                d="M312.576-243.667A9.217,9.217,0,0,0,311-241.922c0,.211.239.239,2.321.239,1.843,0,2.322-.042,2.322-.183a9.259,9.259,0,0,0-1.337-3.194Q314.159-245.186,312.576-243.667Z"
                                transform="translate(-266.729 -248.808)"
                                fill="#3588e6" />
                            <path id="Path_17010" data-name="Path 17010"
                                d="M277.817-234.747a.677.677,0,0,0,.478.872.662.662,0,0,0,.408-.309A.487.487,0,0,0,278.3-235,.584.584,0,0,0,277.817-234.747Z"
                                transform="translate(-238.175 -257.461)"
                                fill="#3588e6" />
                            <path id="Path_17011" data-name="Path 17011"
                                d="M272.473-218.592a1.18,1.18,0,0,0-.2,1.548,1.281,1.281,0,0,0,2.124.2,1.3,1.3,0,0,0-1-2.153A1.2,1.2,0,0,0,272.473-218.592Z"
                                transform="translate(-233.281 -271.21)"
                                fill="#3588e6" />
                            <path id="Path_17012" data-name="Path 17012"
                                d="M256.273-213.716c-.366.45.183,1.14.675.83a.511.511,0,0,0,.084-.858C256.709-213.983,256.484-213.969,256.273-213.716Z"
                                transform="translate(-219.599 -275.58)"
                                fill="#3588e6" />
                            <path id="Path_17013" data-name="Path 17013"
                                d="M299.289-213.625c-.281.267-.281.535-.028.76a.552.552,0,0,0,.9-.253C300.26-213.737,299.711-214.061,299.289-213.625Z"
                                transform="translate(-256.48 -275.657)"
                                fill="#3588e6" />
                            <path id="Path_17014" data-name="Path 17014"
                                d="M219-198.789a9.766,9.766,0,0,0,1.013,2.73l.436.746,1.646-1.646a7.852,7.852,0,0,0,1.59-1.843c-.056-.155-.563-.2-2.378-.2C219.324-199,219-198.972,219-198.789Z"
                                transform="translate(-187.672 -288.396)"
                                fill="#3588e6" />
                            <path id="Path_17015" data-name="Path 17015"
                                d="M311-198.747a10.281,10.281,0,0,0,1.6,1.843l1.6,1.6.436-.76a9.559,9.559,0,0,0,1-2.744c0-.155-.436-.2-2.322-.2C311.2-199,311-198.986,311-198.747Z"
                                transform="translate(-266.729 -288.396)"
                                fill="#3588e6" />
                            <path id="Path_17016" data-name="Path 17016"
                                d="M277.659-191.711c-.1.211-.07.338.113.577a.523.523,0,1,0,.872-.577A.592.592,0,0,0,277.659-191.711Z"
                                transform="translate(-238.03 -294.433)"
                                fill="#3588e6" />
                            <path id="Path_17017" data-name="Path 17017"
                                d="M246.576-179.41A22.855,22.855,0,0,0,245-177.736a10.538,10.538,0,0,0,3.5,1.52,6.7,6.7,0,0,0,.155-2.307c0-1.97-.028-2.321-.225-2.392-.127-.042-.225-.084-.239-.084S247.448-180.283,246.576-179.41Z"
                                transform="translate(-210.014 -303.864)"
                                fill="#3588e6" />
                            <path id="Path_17018" data-name="Path 17018"
                                d="M292.144-180.816a17.454,17.454,0,0,0-.056,4.685c.647,0,3.531-1.238,3.531-1.52a41.506,41.506,0,0,0-3.236-3.25A.816.816,0,0,0,292.144-180.816Z"
                                transform="translate(-250.363 -303.949)"
                                fill="#3588e6" />
                            <path id="Path_17019" data-name="Path 17019"
                                d="M998.744-313.449a14.758,14.758,0,0,0-11.213,10.679,16.676,16.676,0,0,0-.338,5.783,14.915,14.915,0,0,0,4.474,8.568,14.788,14.788,0,0,0,13.971,3.5,17.262,17.262,0,0,0,5.347-2.758,14.658,14.658,0,0,0,.943-21.948,13.225,13.225,0,0,0-4.08-2.786,12.663,12.663,0,0,0-5.726-1.28A11.723,11.723,0,0,0,998.744-313.449Zm6.261,4.4a10.57,10.57,0,0,1,6.838,7.119,12.322,12.322,0,0,1,.07,5.459,10.592,10.592,0,0,1-12.817,7.541,11.028,11.028,0,0,1-5.656-3.757,10.53,10.53,0,0,1-1-11.213,8.015,8.015,0,0,1,1.942-2.533,8.178,8.178,0,0,1,2.547-1.956,9.044,9.044,0,0,1,5.121-1.083A8.116,8.116,0,0,1,1005.005-309.045Z"
                                transform="translate(-847.686 -189.832)"
                                fill="#3588e6" />
                            <path id="Path_17020" data-name="Path 17020"
                                d="M1057.153-271.719a8.246,8.246,0,0,0-2.153,1.125,23.061,23.061,0,0,0,1.6,1.674c1.126,1.126,1.674,1.576,1.829,1.52.2-.07.225-.408.225-2.35V-272l-.38.014A4.5,4.5,0,0,0,1057.153-271.719Z"
                                transform="translate(-906.052 -225.667)"
                                fill="#3588e6" />
                            <path id="Path_17021" data-name="Path 17021"
                                d="M1102-270.021c0,1.956.028,2.279.225,2.364.31.113,3.475-3.039,3.292-3.264a10.551,10.551,0,0,0-2.912-1.28l-.6-.1Z"
                                transform="translate(-946.44 -225.409)"
                                fill="#3588e6" />
                            <path id="Path_17022" data-name="Path 17022"
                                d="M1030.069-245.751a9.436,9.436,0,0,0-1.069,2.729c0,.267.1.281,2.321.281,1.773,0,2.321-.042,2.321-.183a12.8,12.8,0,0,0-1.6-1.773l-1.6-1.6Z"
                                transform="translate(-883.71 -247.751)"
                                fill="#3588e6" />
                            <path id="Path_17023" data-name="Path 17023"
                                d="M1122.18-244.424a8.574,8.574,0,0,0-1.492,1.759,17.455,17.455,0,0,0,4.685.056c0-.633-1.238-3.391-1.519-3.391A22.792,22.792,0,0,0,1122.18-244.424Z"
                                transform="translate(-962.497 -248.009)"
                                fill="#3588e6" />
                            <path id="Path_17024" data-name="Path 17024"
                                d="M1087.227-234.7c-.239.239-.211.45.1.732.225.2.323.211.577.084a.509.509,0,0,0-.141-.957A.714.714,0,0,0,1087.227-234.7Z"
                                transform="translate(-933.608 -257.595)"
                                fill="#3588e6" />
                            <path id="Path_17025" data-name="Path 17025"
                                d="M1082.488-218.564a1.289,1.289,0,0,0,1.547,2.026,1.3,1.3,0,0,0-.647-2.462A.953.953,0,0,0,1082.488-218.564Z"
                                transform="translate(-929.375 -271.21)"
                                fill="#3588e6" />
                            <path id="Path_17026" data-name="Path 17026"
                                d="M1066.178-213.739a.552.552,0,0,0,.253.9c.619.1.943-.45.507-.872C1066.67-213.993,1066.4-213.993,1066.178-213.739Z"
                                transform="translate(-915.541 -275.57)"
                                fill="#3588e6" />
                            <path id="Path_17027" data-name="Path 17027"
                                d="M1109.4-213.817a.507.507,0,0,0,.1.858c.521.324,1.083-.492.577-.858a1.155,1.155,0,0,0-.338-.183A1.168,1.168,0,0,0,1109.4-213.817Z"
                                transform="translate(-952.63 -275.507)"
                                fill="#3588e6" />
                            <path id="Path_17028" data-name="Path 17028"
                                d="M1029-198.719a10.041,10.041,0,0,0,1.041,2.744l.394.675,1.632-1.632c1.139-1.14,1.59-1.688,1.533-1.843-.085-.2-.408-.225-2.35-.225C1029.113-199,1029-198.986,1029-198.719Z"
                                transform="translate(-883.71 -288.396)"
                                fill="#3588e6" />
                            <path id="Path_17029" data-name="Path 17029"
                                d="M1120.689-198.831a8.455,8.455,0,0,0,1.562,1.829l1.632,1.66.38-.6a11.891,11.891,0,0,0,1.111-2.856c0-.169-.394-.2-2.307-.2C1121.351-199,1120.731-198.958,1120.689-198.831Z"
                                transform="translate(-962.497 -288.396)"
                                fill="#3588e6" />
                            <path id="Path_17030" data-name="Path 17030"
                                d="M1087.533-191.733a.5.5,0,0,0,.281.788.518.518,0,0,0,.661-.619A.5.5,0,0,0,1087.533-191.733Z"
                                transform="translate(-933.928 -294.411)"
                                fill="#3588e6" />
                            <path id="Path_17031" data-name="Path 17031"
                                d="M1056.576-179.41a22.861,22.861,0,0,0-1.576,1.674c0,.281,2.828,1.52,3.475,1.52.14,0,.183-.478.183-2.307,0-1.97-.028-2.321-.225-2.392-.126-.042-.225-.084-.239-.084S1057.448-180.283,1056.576-179.41Z"
                                transform="translate(-906.052 -303.864)"
                                fill="#3588e6" />
                            <path id="Path_17032" data-name="Path 17032"
                                d="M1102.183-180.313c-.141.042-.183.661-.183,2.378a12.613,12.613,0,0,0,.112,2.307,11.25,11.25,0,0,0,3.363-1.379C1105.7-177.148,1102.436-180.412,1102.183-180.313Z"
                                transform="translate(-946.44 -304.452)"
                                fill="#3588e6" />
                        </g>
                    </g>
                );

            case 'property':
                return (
                    <g id="Group_15" data-name="Group 15"
                        transform="translate(-562 -325)">
                        <rect id="Rectangle_3349"
                            data-name="Rectangle 3349" width="238"
                            height="238" rx="119"
                            transform="translate(562 325)"
                            fill="#f4f7fe" />
                        <g id="_308936" data-name="308936"
                            transform="translate(528.117 1514.319)">
                            <path id="Path_17033" data-name="Path 17033"
                                d="M138.563-1117.321l-31.156,27.589c-9.442,8.36-17.184,15.245-17.207,15.293-.036.1,6.386,7.373,6.517,7.373.048,0,4.84-4.21,10.655-9.371s18.016-15.947,27.089-23.986,16.958-15.019,17.5-15.483l.975-.868,28.041,24.854c15.435,13.664,28.112,24.842,28.172,24.842s1.558-1.641,3.318-3.639c2.331-2.652,3.175-3.675,3.092-3.793-.059-.083-14.092-12.534-31.168-27.672-27.41-24.259-31.121-27.505-31.454-27.517C152.583-1129.713,151.2-1128.511,138.563-1117.321Z"
                                transform="translate(0)"
                                fill="#3588e6" />
                            <path id="Path_17034" data-name="Path 17034"
                                d="M247-1052.2v11.8l.392-.357c.369-.357,15.221-13.747,15.269-13.771,0-.012.059-2.141.107-4.745l.083-4.721H247Z"
                                transform="translate(-138.155 -57.888)"
                                fill="#3588e6" />
                            <path id="Path_17035" data-name="Path 17035"
                                d="M285.934-945.3c-2.806,2.5-12.724,11.285-22.023,19.514L247-910.817v28.2c0,27.054.012,28.219.226,28.671a2.8,2.8,0,0,0,1.427,1.391c.333.119,3.4.155,14.46.155h14.032l.059-12.665c.06-11.713.071-12.688.262-13.045a2.936,2.936,0,0,1,1.51-1.213c.333-.1,3.746-.131,12.213-.131,11.166,0,11.785.012,12.249.226a2.842,2.842,0,0,1,1.463,1.819q.125.589.131,12.819v12.248h13.83c15,0,14.484.024,15.352-.642a2.659,2.659,0,0,0,.654-.82l.25-.511.012-28.243.012-28.231-3.734-3.33c-3.437-3.068-39.766-35.235-40.17-35.568C291.083-949.81,290.25-949.12,285.934-945.3Z"
                                transform="translate(-138.155 -158.592)"
                                fill="#3588e6" />
                        </g>
                    </g>
                );

            case 'policy':
                return (
                    <g id="Group_1" data-name="Group 1"
                        transform="translate(-577 -345)">
                        <rect id="Rectangle_3349"
                            data-name="Rectangle 3349" width="238"
                            height="238" rx="119"
                            transform="translate(577 345)"
                            fill="#f4f7fe" />
                        <path id="diploma"
                            d="M55.1,77.339a6.445,6.445,0,1,1,0,12.89H35.561a6.445,6.445,0,1,1,0-12.89ZM94.172,58a6.479,6.479,0,0,0-6.512-6.445h-52.1a6.445,6.445,0,1,0,0,12.89h52.1A6.479,6.479,0,0,0,94.172,58ZM35.561,38.669h52.1a6.445,6.445,0,1,0,0-12.89h-52.1a6.445,6.445,0,1,0,0,12.89Zm78.147,86.645v24.7a4.647,4.647,0,0,1-2.9,4.3,4.731,4.731,0,0,1-5.118-1.008l-5.008-4.95-5.008,4.95a4.731,4.731,0,0,1-5.118,1.008,4.647,4.647,0,0,1-2.9-4.3v-24.7a25.587,25.587,0,0,1-12.14-28.947A25.76,25.76,0,0,1,107.2,78.254V32.224A19.436,19.436,0,0,0,87.659,12.89h-52.1A19.437,19.437,0,0,0,16.025,32.224v77.339A19.437,19.437,0,0,0,35.561,128.9H68.123a6.445,6.445,0,1,1,0,12.89H35.561A32.433,32.433,0,0,1,3,109.563V32.224A32.433,32.433,0,0,1,35.561,0h52.1a32.433,32.433,0,0,1,32.561,32.224V86.246a25.308,25.308,0,0,1-6.512,39.069Zm0-22.2a13.025,13.025,0,1,0-13.025,12.89A12.958,12.958,0,0,0,113.708,103.118Z"
                            transform="translate(632.245 394.333)"
                            fill="#207be3" />
                    </g>
                );
            case 'trash':
                return (
                    <g id="Group_12" data-name="Group 12" transform="translate(-562 -325)">
                        <rect id="Rectangle_3349" data-name="Rectangle 3349" width="238" height="238" rx="119" transform="translate(562 325)" fill="#f4f7fe"></rect>
                        <g id="delete" transform="translate(619.545 367.334)">
                            <path id="Path_49" data-name="Path 49" d="M225.974,154.7a3.575,3.575,0,0,0-3.575,3.575v67.57a3.575,3.575,0,0,0,7.15,0v-67.57A3.575,3.575,0,0,0,225.974,154.7Zm0,0" transform="translate(-143.62 -100.72)" fill="#3588e6"></path>
                            <path id="Path_50" data-name="Path 50" d="M107.974,154.7a3.575,3.575,0,0,0-3.575,3.575v67.57a3.575,3.575,0,0,0,7.15,0v-67.57A3.575,3.575,0,0,0,107.974,154.7Zm0,0" transform="translate(-67.418 -100.72)" fill="#3588e6"></path>
                            <path id="Path_51" data-name="Path 51" d="M10.063,45.052v87.319a19.553,19.553,0,0,0,5.2,13.486,17.453,17.453,0,0,0,12.663,5.475H94.979a17.448,17.448,0,0,0,12.663-5.475,19.553,19.553,0,0,0,5.2-13.486V45.052a13.538,13.538,0,0,0-3.473-26.624H91.222V14A13.921,13.921,0,0,0,77.187,0H45.717A13.921,13.921,0,0,0,31.681,14v4.43H13.536a13.538,13.538,0,0,0-3.473,26.624Zm84.917,99.192H27.924c-6.06,0-10.773-5.205-10.773-11.873V45.363h88.6v87.007C105.753,139.038,101.039,144.243,94.979,144.243ZM38.77,14a6.828,6.828,0,0,1,6.947-6.911h31.47A6.828,6.828,0,0,1,84.134,14v4.43H38.77ZM13.536,25.517h95.831a6.379,6.379,0,0,1,0,12.759H13.536a6.379,6.379,0,0,1,0-12.759Zm0,0" transform="translate(0.003 0.001)" fill="#3588e6"></path>
                            <path id="Path_52" data-name="Path 52" d="M166.974,154.7a3.575,3.575,0,0,0-3.575,3.575v67.57a3.575,3.575,0,0,0,7.15,0v-67.57A3.575,3.575,0,0,0,166.974,154.7Zm0,0" transform="translate(-105.518 -100.72)" fill="#3588e6"></path>
                        </g>
                    </g>
                );

        }
    }

    const addNewModalClick = () => {
        switch (selectedTabIdState) {
            case 'user':
                setOpenModal({
                    ...openModal,
                    userModal: !openModal.userModal
                })
                break;
            case 'client':
                setOpenModal({
                    ...openModal,
                    clientModal: !openModal.clientModal
                })
                break;
            case 'mvr':
            case 'mvr_submission':
            case 'approved':
            case 'not_approved':
            case 'all_approvals':
                setOpenModal({
                    ...openModal,
                    mvrModal: !openModal.mvrModal
                })
                break;
            case 'thirdParty':
                setOpenModal({
                    ...openModal,
                    thirdPartyModal: !openModal.thirdPartyModal
                })
                break;
            case 'incident':
                setOpenModal({
                    ...openModal,
                    incidentModal: !openModal.incidentModal
                })
                break;
            case 'claim':
                setOpenModal({
                    ...openModal,
                    claimModal: !openModal.claimModal
                })
                break;
            case 'employee':
                setOpenModal({
                    ...openModal,
                    employeeModal: !openModal.employeeModal
                })
                break;
            case 'vehicle':
                setOpenModal({
                    ...openModal,
                    vehicleModal: !openModal.vehicleModal
                })
                break;
            case 'property':
                setOpenModal({
                    ...openModal,
                    propertyModal: !openModal.propertyModal
                })
                break;
            case 'policy':
                setOpenModal({
                    ...openModal,
                    policyModal: !openModal.policyModal
                })
                break;
            default:
                break;
        }
    }

    const openModalSwitch = () => {
        switch (true) {
            case openModal.userModal:
                return (
                    <UserModal
                        title={'Add New User'}
                        data={null}
                        isOpen={openModal.userModal}
                        onClose={addNewModalClick}
                    />
                );
            case openModal.clientModal:
                return (
                    <ClientModal
                        title={'Add New Client'}
                        data={null}
                        isOpen={openModal.clientModal}
                        onClose={addNewModalClick}
                    />
                );
            case openModal.mvrModal:
                return (
                    <GenerateLinkModal
                        isOpen={openModal.mvrModal}
                        onClose={addNewModalClick}
                    />
                );
            case openModal.thirdPartyModal:
                return (
                    <ThirdPartyModal
                        title={'Add New Third Party'}
                        data={null}
                        isOpen={openModal.thirdPartyModal}
                        onClose={addNewModalClick}
                    />
                );
            case openModal.claimModal:
                return (
                    <DirectClaimModal
                        data={null}
                        isOpen={openModal.claimModal}
                        onClose={addNewModalClick}
                    />
                );
            case openModal.employeeModal:
                return (
                    <EmployeeModal
                        title={'Add New Employee'}
                        data={null}
                        isOpen={openModal.employeeModal}
                        onClose={addNewModalClick}
                    />
                );
            case openModal.vehicleModal:
                return (
                    <VehicleModal
                        title={'Add New Vehicle'}
                        data={null}
                        isOpen={openModal.vehicleModal}
                        onClose={addNewModalClick}
                    />
                );
            case openModal.propertyModal:
                return (
                    <PropertyModal
                        title={'Add New Property'}
                        data={null}
                        isOpen={openModal.propertyModal}
                        onClose={addNewModalClick}
                    />
                );
            case openModal.policyModal:
                return (
                    <PolicyModal
                        title={'Add New Policy'}
                        data={null}
                        isOpen={openModal.policyModal}
                        onClose={addNewModalClick}
                    />
                );
            default:
                break;
        }
    }

    return (
        <>
            {(data && data.length > 0) ? (
                <div className={className ? className : "pl-6 user-mang assetmanag "}>
                    <div className="container-fluid">
                        <div id="tabs" className="project-tab">
                            <div className="tab-content" id="nav-tabContent">
                                <div className="tab-pane fade show active" role="tabpanel" style={{ position: "relative" }}>
                                    {tableView}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
                : (
                    <div className="py-5">
                        <div className="text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="200"
                                height="200" viewBox="0 0 238 238">
                                {renderswitch()}
                            </svg>
                        </div>
                        <div className="text-center">
                            <h2 className="no-comment mt-5">No Data Found Yet Here</h2>
                            <p className="all-comment my-3">All data related to this module will show up here</p>
                            {(createPermission && selectedTabIdState !== 'trash') &&
                                <a className="all-comment my-3" style={{ cursor: 'pointer', color: '#07448a' }} onClick={() => addNewModalClick()}> Get Started </a>
                            }
                        </div>
                    </div>
                )}
            {openModalSwitch()}
        </>
    )
}

export default Table
